import React from 'react';
import styles from './NavList.scss';
import classNames from 'classnames';
import { NavigationItemType } from '../../mobile-menu-item/itemTypes';

export const NavList = ({
  inlineChild,
  itemType,
  name,
  children,
}: {
  inlineChild?: boolean;
  itemType: NavigationItemType;
  name: string;
  children: React.ReactNode;
}) => {
  return (
    <ul
      data-testid="submenu-nav-list"
      className={classNames(styles.list, styles[itemType], {
        [styles.inlineChild]: inlineChild,
      })}
    >
      {React.Children.toArray(children).map((child, index) => (
        <li
          key={`${name}-${index}`}
          className={classNames(styles.listItem, styles[`pos-${index + 1}`])}
        >
          {child}
        </li>
      ))}
    </ul>
  );
};
